import { put, call } from "redux-saga/effects";
import {
 
    UPDATE_LAWFIRM_SUCESS, UPDATE_LAWFIRM_FAILED,
    GET_LAWFIRM_SUCESS, GET_LAWFIRM_FAILED,
    ADD_LAWFIRM_SUCESS, ADD_LAWFIRM_FAILED,
    UPDATE_ATTORNEY_SUCESS, UPDATE_ATTORNEY_FAILED,
    GET_ATTORNEY_SUCESS, GET_ATTORNEY_FAILED,
    ADD_ATTORNEY_SUCESS, ADD_ATTORNEY_FAILED,
    UPDATE_LF_CORPORATE_SUCESS, UPDATE_LF_CORPORATE_FAILED,
    GET_LF_CORPORATE_SUCESS, GET_LF_CORPORATE_FAILED,
    ADD_LF_CORPORATE_SUCESS, ADD_LF_CORPORATE_FAILED,
    GET_LAWFIRMCASEFLOW_SUCESS, GET_LAWFIRMCASEFLOW_FAILED,
    GET_ALLLAWFIRM_SUCESS, GET_ALLLAWFIRM_FAILED,

    
} from "../actions/LawFirm";
import { AddLawFirmAPI } from "../../utils/api/AddLawFirmAPI";

 

export function* addLawFirmDetails(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddLawFirmAPI.addLawFirmDetails, request.input);
        yield put({
            type: ADD_LAWFIRM_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: ADD_LAWFIRM_FAILED, payload: e.message });
    }
}

export function* updateLawFirmDetails(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddLawFirmAPI.updateLawFirmDetails, request.input);
        yield put({
            type: UPDATE_LAWFIRM_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_LAWFIRM_FAILED, payload: e.message });
    }
}
export function* getAllLawFirmDetails(request: any) {
    try {
        const { data } = yield call(AddLawFirmAPI.getAllLawFirmDetails, request);

        yield put({
            type: GET_LAWFIRM_SUCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_LAWFIRM_FAILED, payload: e.message });
    }
}

export function* addAttorneyDetails(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddLawFirmAPI.addAttorneyDetails, request.input);
        yield put({
            type: ADD_ATTORNEY_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: ADD_ATTORNEY_FAILED, payload: e.message });
    }
}

export function* updateAttorneyDetails(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddLawFirmAPI.updateAttorneyDetails, request.input);
        yield put({
            type: UPDATE_ATTORNEY_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_ATTORNEY_FAILED, payload: e.message });
    }
}
export function* getAllAttorneyDetails(request: any) {
    try {
        const { data } = yield call(AddLawFirmAPI.getAllAttorneyDetails, request);

        yield put({
            type: GET_ATTORNEY_SUCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_ATTORNEY_FAILED, payload: e.message });
    }
}

export function* addCorporateDetails(request: any) {
       alert("addCorporateDetails sagas");
    try {
        const result = yield call(AddLawFirmAPI.addCorporateDetails, request.input);
        yield put({
            type: ADD_LF_CORPORATE_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: ADD_LF_CORPORATE_FAILED, payload: e.message });
    }
}

export function* updateCorporateDetails(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddLawFirmAPI.updateCorporateDetails, request.input);
        yield put({
            type: UPDATE_LF_CORPORATE_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_LF_CORPORATE_FAILED, payload: e.message });
    }
}
export function* getAllCorporateDetails(request: any) {
    try {
        const { data } = yield call(AddLawFirmAPI.getAllCorporateDetails, request);

        yield put({
            type: GET_LF_CORPORATE_SUCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_LF_CORPORATE_FAILED, payload: e.message });
    }
}

export function* getAllCaseflowsByLawfirmId(request: any) {
    try {
        const { data } = yield call(AddLawFirmAPI.getAllCaseflowsByLawfirmId, request);

        yield put({
            type: GET_LAWFIRMCASEFLOW_SUCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_LAWFIRMCASEFLOW_FAILED, payload: e.message });
    }
}

export function* getAllLawFirmDetail() {
    try {
        const { data } = yield call(AddLawFirmAPI.getAllLawFirmDetail);

        yield put({
            type: GET_ALLLAWFIRM_SUCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_ALLLAWFIRM_FAILED, payload: e.message });
    }
}